import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import DashboardSection from "./DashboardSection";
import AwareIcon from "./svg/icon-aware.svg";
import { colors } from "../../theme";
import Avatar from "../shared/Avatar";
import { Link } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import {
  PublicUserProfile,
  getMostActiveUsers,
} from "../../firebase/users";

const useStyles = makeStyles({
  a: {
    width: "100%",
    textAlign: "center",
  },
  container: {
    justifyContent: "center",
    textAlign: "center",
  },
  userContainer: {
    backgroundColor: colors.BACKGROUND_SECONDARY,
    paddingTop: "75px",
    paddingBottom: "50px",
  },
  title: {
    fontSize: "32px",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "2.66",
    letterSpacing: "-0.06px",
    color: colors.TEXT_PRIMARY,
  },
  description: {
    fontSize: "20px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.67,
    letterSpacing: "-0.05px",
  },
  avatar: {
    width: "150px",
    height: "150px",
    fontSize: "82px",
    margin: "0 auto",
    border: "2px solid #FFFFFF",
    color: colors.AVATAR_LETTER_TEXT,
  },
  userNamelink: {
    width: "100%",
    textAlign: "center",
    "&:hover": {
      textDecoration: "none",
    }
  },
  userName: {
    paddingTop: "20px",
    paddingBottom: "24px",
    color: colors.LINK,
    textAlign: "center",
    fontSize: "20px",
    fontWeight: "bold",
  }
});

export default function UserContribution() {
  const classes = useStyles();
  const { t } = useTranslation();
  const [usersPopular, setUsersPopular] = useState<
    PublicUserProfile[]
  >([]);

  useEffect(() => {
    async function fetchUsersPopular() {
      const users = await getMostActiveUsers();

      setUsersPopular(users);
    }
    fetchUsersPopular();
  });

  return (
    <Grid container item className={classes.userContainer}>
      <Grid container item >
        <DashboardSection
          title={t("dashboard_contribution.title")}
          icon={AwareIcon}
        />
      </Grid>
      <Grid container item >
        <p className={classes.description}>
          {t("dashboard_contribution.description")}
        </p>
      </Grid>
      {usersPopular.map((user) => (
        <Grid className={classes.container} item xs={12} sm={6} md={3} key={user.id}>
          <Avatar className={classes.avatar}>{user.avatar}</Avatar>
          <Grid container item className={classes.userName}>
            <Link component={RouterLink} to={`/profile/${user.id}`} className={classes.userNamelink}>
            <b className={classes.userName}>
              {user.displayname}
              </b>
            </Link>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
}
